import { Link } from "react-router-dom";
import { ArrowRight, Factory, Wrench, Globe2, Cog, Layers, Zap, Award, ShieldCheck } from "lucide-react";
import { useContent, renderRich } from "@/context/ContentContext";

const ICONS = { Factory, Wrench, Globe2, Cog, Layers, Zap, Award, ShieldCheck };
const Icon = ({ name, ...rest }) => {
    const C = ICONS[name] || Factory;
    return <C {...rest} />;
};

const About = () => {
    const c = useContent();
    const a = c.about || {};

    return (
        <div data-testid="about-page">
            <section className="bg-gray-900 text-white">
                <div className="max-w-7xl mx-auto px-6 md:px-12 pt-24 md:pt-32 pb-20 grid md:grid-cols-12 gap-10 items-end">
                    <div className="md:col-span-7">
                        <div className="overline text-red-600 mb-6">{a.hero_overline}</div>
                        <h1 className="font-display font-black uppercase tracking-tighter text-5xl md:text-7xl leading-[0.95]">
                            {renderRich(a.hero_heading)}
                        </h1>
                    </div>
                    <div className="md:col-span-5">
                        <p className="text-gray-300 text-lg leading-relaxed">{a.hero_paragraph}</p>
                    </div>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
                <div className="grid md:grid-cols-12 gap-10 md:gap-16">
                    <div className="md:col-span-5">
                        <div className="overline text-red-600 mb-4">{a.approach_overline}</div>
                        <h2 className="font-display font-black uppercase tracking-tight text-3xl md:text-4xl">
                            {renderRich(a.approach_heading)}
                        </h2>
                    </div>
                    <div className="md:col-span-7 text-gray-700 space-y-5 leading-relaxed">
                        <p>{a.approach_body1}</p>
                        <p>{a.approach_body2}</p>
                    </div>
                </div>
            </section>

            <section className="bg-gray-50 border-y border-gray-200">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 grid md:grid-cols-3 gap-0 border-t border-l border-gray-200">
                    {(a.features || []).map((f, i) => (
                        <div key={i} className="border-r border-b border-gray-200 p-10 bg-white" data-testid={`about-feature-${i}`}>
                            <Icon name={f.icon} className="text-red-600 mb-6" size={28} strokeWidth={1.5} />
                            <h3 className="font-display font-bold text-2xl mb-3">{f.title}</h3>
                            <p className="text-sm text-gray-600 leading-relaxed">{f.body}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 grid md:grid-cols-12 gap-10 items-end">
                <div className="md:col-span-8">
                    <div className="overline text-red-600 mb-4">{a.cta_overline}</div>
                    <h2 className="font-display font-black uppercase tracking-tighter text-4xl md:text-6xl">
                        {renderRich(a.cta_heading)}
                    </h2>
                </div>
                <div className="md:col-span-4 flex md:justify-end">
                    <Link to="/contact" className="btn-dark" data-testid="about-cta">
                        {a.cta_button} <ArrowRight size={16} />
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default About;
